import React from 'react'
import { FaInstagram } from "react-icons/fa";
import Enamad from "../assets/images/eNamad.png"
const Footer = () => {
  return (
<div className="flex flex-col lg:h-[300px] h-auto justify-between px-6 sm:px-10 lg:px-20 pt-5 w-full text-white shadow-sm bg-special">

    <div className="w-full items-center h-full flex flex-col lg:flex-row justify-between gap-8 lg:gap-0 pb-6">

             {/* لینک‌ها */}
        <div className="w-full lg:w-[220px] flex flex-col items-center text-center lg:text-center gap-2">
            <p className=" text-lg sm:text-lg lg:text-md">ارتباط سریع</p>
            <div className="flex flex-col gap-۱">
                <p className="text-xs sm:text-sm  cursor-pointer hover:text-blue-600">ثبت بار</p>
                <p className="text-xs sm:text-sm  cursor-pointer hover:text-blue-600">جست‌وجوی راننده</p>
                <p className="text-xs sm:text-sm  cursor-pointer hover:text-blue-600">فروشگاه</p>
                <p className="text-xs sm:text-sm  cursor-pointer hover:text-blue-600">خرید و فروش و اجاره خودرو</p>
            </div>
        </div>

         {/* تماس با ما */}
         <div className="w-full lg:w-[220px] flex flex-col items-center  text-center lg:text-center gap-2">
                <p className=" text-lg sm:text-lg lg:text-md">ارتباط با ما</p>
                <div className="flex flex-col gap-1 ">
                    <p className="text-xs sm:text-sm ">ایران، تهران، خیابان اصلی، پلاک ۱۲۳</p>
                    <p className="text-xs sm:text-sm ">تلفن: ۰۲۱-۱۲۳۴۵۶۷۸</p>
                    <p className="text-xs sm:text-sm ">ایمیل: info@barsara.com</p>
                </div>
        </div>

        {/* معرفی */}
        <div className="w-full lg:w-[220px] flex flex-col items-center  text-center lg:text-center gap-2">
            <p className=" text-lg sm:text-lg lg:text-md">بارسرا</p>
            <p className="text-xs sm:text-sm  leading-relaxed ">
                بارسرا پلتفرمی پیشرو در صنعت حمل و نقل بار است که با اتصال صاحبان بار و رانندگان، فرآیند حمل و نقل را ساده‌تر، سریع‌تر و کارآمدتر می‌کند.
            </p>
        </div>

        <img className='w-[100px] rounded-lg' src={Enamad}></img>
    

       
    </div>

    {/* کپی‌رایت */}
    <div className="flex justify-center items-center text-[10px] sm:text-xs lg:text-sm h-[40px] text-gray-white">
        <p className="font-medium">© 2025 بارسرا. تمامی حقوق محفوظ است.</p>
    </div>
</div>

  )
}

export default Footer
